<script setup>
import { computed } from 'vue';

const props = defineProps({
    percentage: {
        type: Number,
        default: 0
    },
});

// --- Computed ---

const percentageWidth = computed(() => {
    return props.percentage + '%';
});
</script>

<template>
    <div class="progress">
        <div
            :style="{ width: percentageWidth }"
            aria-valuemax="100"
            aria-valuemin="0"
            class="progress-bar"
            role="progressbar"
        >
            <span class="visually-hidden">{{ percentage }}% Complete</span>
        </div>
    </div>
</template>

<style scoped>
/* Overwrite Bootstrap's height */
.progress {
    margin-bottom: 0;
    height: 3px;
}
</style>